// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Caml from "../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "./CSS.bs.js";
import * as Throttle$Showside from "./Throttle.bs.js";
import * as DataAttribute$Showside from "./DataAttribute.bs.js";
var getTouchY = function getTouchY(e) {
  return e.touches ? e.touches[0].pageY : 0;
};
function PullDown(Props) {
  var onPullDownOpt = Props.onPullDown;
  var classNameOpt = Props.className;
  var childrenOpt = Props.children;
  var scaleOpt = Props.scale;
  var limit = Props.limit;
  var touchNoneOpt = Props.touchNone;
  var dataTestId = Props.dataTestId;
  var onPullDown = onPullDownOpt !== undefined ? onPullDownOpt : function (param) {};
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var children = childrenOpt !== undefined ? Caml_option.valFromOption(childrenOpt) : null;
  var scale = scaleOpt !== undefined ? scaleOpt : 1.0;
  var touchNone = touchNoneOpt !== undefined ? touchNoneOpt : true;
  var match = React.useState(function () {});
  var setDragStart = match[1];
  var dragging = match[0];
  var match$1 = Throttle$Showside.use(30, true, function (param) {
    return 0.0;
  });
  var setOffsetY = match$1[1];
  var offsetY = match$1[0];
  var onTouchStart = function (e) {
    e.stopPropagation();
  };
  var onTouchMove = function (e) {
    var touchY = getTouchY(e);
    if (dragging === undefined) {
      Curry._1(setDragStart, function (param) {
        return touchY;
      });
    } else if (dragging !== undefined) {
      Curry._1(setOffsetY, function (param) {
        return Caml.float_max(touchY - dragging, 0.0) * scale;
      });
    }
    e.stopPropagation();
  };
  var onTouchEnd = function (e) {
    if (offsetY > 20.0) {
      Curry._1(onPullDown, undefined);
    }
    Curry._1(setOffsetY, function (param) {
      return 0.0;
    });
    Curry._1(setDragStart, function (param) {});
    e.stopPropagation();
  };
  var style = {
    transform: CSS$Showside.translate3d_float(0.0, limit !== undefined ? Math.max(offsetY, limit) : offsetY, 0.0)
  };
  var tmp = {
    children: React.createElement("div", {
      className: Cn.make([CSS$Showside.prefix("absolute inset-0"), touchNone ? CSS$Showside.prefix("touch-none") : "", dragging === undefined ? CSS$Showside.prefix("transform-translate duration-250") : "", className]),
      style: style,
      onTouchEnd: onTouchEnd,
      onTouchMove: onTouchMove,
      onTouchStart: onTouchStart
    }, children)
  };
  if (dataTestId !== undefined) {
    tmp.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  return React.createElement(DataAttribute$Showside.make, tmp);
}
PullDown.displayName = "PullDown";
var make = PullDown;
export { getTouchY, make };
/* react Not a pure module */